module.exports = __webpack_public_path__ + "fonts/deposit-guide-2.b610e12es.png";